import {styled} from '@mui/material/styles';
import {useState} from 'react';
import FormHelperText from '@mui/material/FormHelperText';

import {PeriodType} from 'modules/decisionsNext/api/types';
import {DateRangeValueProps} from 'features/GlobalFilterProvider/filters/period/DateRangeItem/types';

import {dayjs, formatDateToString} from 'utils/dateUtils';

import {getValidationError} from 'components/DatePicker/DesktopDatePicker';
import Switch from 'components/form-next/Switch';

import {
  InforceDatePicker,
  inforceMaxDateValidation,
  inforceMinDateValidation,
} from 'modules/decisionsNext/components/BaseFilter/Dialog/components/DateRangeBlock/InforceDatePicker';

const todayString = formatDateToString();
const invalidDate = dayjs(null).toString();

const SRoot = styled('div')(() => ({
  display: 'gap',
}));

const SContent = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(6),
}));

const SSwitch = styled(Switch)(({theme}) => ({
  marginTop: theme.spacing(7.5),
}));

export function InForceSelectionGroup({value, updateValue}: DateRangeValueProps) {
  const [pickerValue, setPickerValue] = useState<string>(todayString);
  const errorMessage =
    !value.inForceToday &&
    getValidationError({
      newDate: value.timestamp,
      minDateValidation: inforceMinDateValidation,
      maxDateValidation: inforceMaxDateValidation,
    });

  return (
    <SRoot>
      <SContent>
        <InforceDatePicker
          error={Boolean(errorMessage)}
          disabled={value.inForceToday}
          value={value.inForceToday ? todayString : value.timestamp === invalidDate ? null : value.timestamp}
          onChange={timestamp => {
            if (timestamp && dayjs(timestamp).isValid()) {
              setPickerValue(timestamp);
            }

            updateValue({
              type: PeriodType.InForce,
              timestamp: timestamp ?? invalidDate,
            });
          }}
        />

        <SSwitch
          data-testid='inforce-today-switch'
          label='Today'
          slotProps={{
            typography: {
              variant: 'body3',
            },
          }}
          checked={value.inForceToday}
          onChange={(_, inForceToday) =>
            updateValue({
              inForceToday,
              timestamp: inForceToday ? undefined : pickerValue,
            })
          }
        />
      </SContent>
      <FormHelperText error={true}>{errorMessage}</FormHelperText>
    </SRoot>
  );
}
